import { useAdminAnalyticsHierarchyContext } from '../../contexts/AdminAnalyticsHierarchyContext';
import { writeAdminAnalyticsSelection } from '../../utils/managerAccess';
import AnalyticsBreadcrumbNav from '../analytics/AnalyticsBreadcrumbNav';

function AdminAnalyticsSidebarNav() {
  const hierarchy = useAdminAnalyticsHierarchyContext();
  return (
    <AnalyticsBreadcrumbNav
      hierarchy={hierarchy}
      basePath="/admin/analytics"
      writeSelection={writeAdminAnalyticsSelection}
    />
  );
}

export default AdminAnalyticsSidebarNav;
